import {InjectionToken} from '@angular/core';
import {ISystemService} from './system-service.interface';

export const SYSTEM_SERVICE = new InjectionToken<ISystemService>('SYSTEM_SERVICE');
